/* Different Drips — "Complete the look" add-on (snippets/dd-complete-look.liquid).
   Follows the chain's finish + width, asks only for wrist size, and when the
   toggle is on adds chain + bracelet to the cart in one request, then opens
   Dawn's cart drawer. When the toggle is off, Dawn's normal add-to-cart runs. */
(function () {
  function money(cents) {
    var d = cents / 100;
    return '$' + (d % 1 ? d.toFixed(2) : String(d)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function norm(v) {
    return String(v || '').trim().toLowerCase();
  }

  function init(root) {
    if (root.dataset.ddInit) return;
    root.dataset.ddInit = '1';

    var cfg = JSON.parse(root.querySelector('[data-dd-ctl-config]').textContent);
    var sectionId = root.dataset.section;
    var formEl = document.getElementById('product-form-' + sectionId);
    if (!formEl) return;
    var productForm = formEl.closest('product-form');
    var idInput = formEl.querySelector('[name="id"]');

    var toggle = root.querySelector('[data-dd-ctl-toggle]');
    var thumb = root.querySelector('[data-dd-ctl-thumb]');
    var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('.dd-ctl__size'));
    var el = function (k) { return root.querySelector('[data-dd-ctl-' + k + ']'); };

    var state = { on: false, size: cfg.defaultSize };

    /* gallery card */
    var card = null;
    var viewer = document.getElementById('GalleryViewer-' + sectionId);
    if (viewer) {
      card = document.createElement('div');
      card.className = 'dd-ctl-setcard';
      card.setAttribute('aria-hidden', 'true');
      card.innerHTML =
        '<div class="dd-ctl-setcard__img">' + thumb.innerHTML + '</div>' +
        '<span class="dd-ctl-setcard__label">+ Matching bracelet</span>';
      card.querySelectorAll('img').forEach(function (i) { i.loading = 'eager'; });
      viewer.appendChild(card);
    }

    function chainVariant() {
      return cfg.chain[idInput && idInput.value] || null;
    }
    function matchVariant(cv, sizeIdx) {
      if (!cv) return null;
      var f = norm(cv.o[cfg.chainFinish]);
      var w = norm(cv.o[cfg.chainWidth]);
      var s = norm(cfg.sizes[sizeIdx]);
      for (var i = 0; i < cfg.match.length; i++) {
        var m = cfg.match[i];
        if (norm(m.o[cfg.matchFinish]) === f && norm(m.o[cfg.matchWidth]) === w && norm(m.o[cfg.matchSize]) === s) return m;
      }
      return null;
    }

    function shine() {
      thumb.classList.remove('is-shine');
      void thumb.offsetWidth;
      thumb.classList.add('is-shine');
    }

    var lastKey = '';
    function render() {
      var cv = chainVariant();
      if (!cv) return;
      var finish = cv.o[cfg.chainFinish];
      var width = cv.o[cfg.chainWidth];
      var finishKey = /white|silver/i.test(finish) ? 'white' : 'yellow';
      root.dataset.finish = finishKey;
      if (card) card.dataset.finish = finishKey;

      /* disable sizes that don't exist / are sold out for this finish + width */
      sizeBtns.forEach(function (b, i) {
        var mv = matchVariant(cv, i);
        b.disabled = !mv || !mv.a;
      });
      if (sizeBtns[state.size] && sizeBtns[state.size].disabled) {
        var firstOk = sizeBtns.findIndex(function (b) { return !b.disabled; });
        if (firstOk > -1) state.size = firstOk;
      }
      sizeBtns.forEach(function (b, i) { b.setAttribute('aria-checked', i === state.size ? 'true' : 'false'); });

      var mv = matchVariant(cv, state.size);
      var available = !!(mv && mv.a);
      root.hidden = !sizeBtns.some(function (b) { return !b.disabled; });
      if (root.hidden && state.on) setOn(false);

      var sizeLabel = String(cfg.sizes[state.size] || '').replace(/\s*inch(es)?/i, '"');
      el('spec').textContent = width + ' · ' + finish + ' · ' + (state.on ? sizeLabel : 'Miami Cuban');
      if (mv) {
        el('now').textContent = '+' + money(mv.p);
        el('was').textContent = mv.c > mv.p ? money(mv.c) : '';
        var total = cv.p + mv.p;
        var totalWas = (cv.c > cv.p ? cv.c : cv.p) + (mv.c > mv.p ? mv.c : mv.p);
        el('total-now').textContent = money(total);
        el('total-was').textContent = totalWas > total ? money(totalWas) : '';
        el('total-save').textContent = totalWas > total ? 'You save ' + money(totalWas - total) : '';
      }
      el('matched').innerHTML =
        'Same <b>' + width + '</b> width, same <b>' + finish + '</b> finish as your chain. Change the chain and the bracelet follows.';

      var key = finish + '|' + width;
      if (state.on && lastKey && key !== lastKey) shine();
      lastKey = key;
      root.dataset.available = available ? 'true' : 'false';
    }

    function setOn(on) {
      state.on = on;
      root.classList.toggle('is-on', on);
      if (card) card.classList.toggle('is-on', on);
      toggle.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on) shine();
      render();
    }

    toggle.addEventListener('click', function () { setOn(!state.on); });
    sizeBtns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        state.size = i;
        render();
      });
    });

    /* chain variant changes: Dawn dispatches change on the hidden id input */
    if (idInput) idInput.addEventListener('change', render);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        if (e && e.data && e.data.sectionId === sectionId) setTimeout(render, 0);
      });
    }

    /* add both lines when the toggle is on; runs before Dawn's submit handler */
    if (productForm) {
      productForm.addEventListener('submit', function (evt) {
        if (!state.on || evt.target !== formEl) return;
        var cv = chainVariant();
        var mv = matchVariant(cv, state.size);
        if (!cv || !mv || !mv.a) return; /* fall back to Dawn: chain only */

        evt.preventDefault();
        evt.stopImmediatePropagation();
        evt.stopPropagation();

        var btn = productForm.submitButton || formEl.querySelector('[type="submit"]');
        if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
        if (productForm.handleErrorMessage) productForm.handleErrorMessage();
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        var spinner = productForm.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        var fd = new FormData(formEl);
        var qty = parseInt(fd.get('quantity'), 10) || 1;
        var props = {};
        fd.forEach(function (val, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && typeof val === 'string') props[m[1]] = val;
        });
        var chainId = parseInt(fd.get('id'), 10);
        var items = [
          { id: chainId, quantity: qty, properties: props },
          { id: mv.id, quantity: qty, properties: { _dd_set: 'Complete the look' } }
        ];

        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
          if (drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
        }

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              if (productForm.handleErrorMessage) productForm.handleErrorMessage(res.description || res.message);
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: chainId, cartData: res });
            }
            if (drawer && res.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch(function (e) { console.error(e); })
          .finally(function () {
            btn.classList.remove('loading');
            btn.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }, true);
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-dd-ctl]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
